import api from '../clients/api';
import { handleUnauthorized } from '../utils/apiWrapper';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const service = {
	fetchFederalStates,
	fetchPublishers,
	fetchSchoolTypes,
	fetchAiFilterValues,
	fetchTeachingFormats,
	fetchWorkloads,
	fetchTeacherRoles,
	fetchSchools,
	fetchSchoolStages,
};

function fetchPublishers() {
	notifyBugsnagNetwork('text', 'fetchPublishers');
	return handleUnauthorized(() => {
		return api.text.getPublishers();
	});
}

function fetchSchoolTypes() {
	notifyBugsnagNetwork('text', 'fetchSchoolTypes');
	return handleUnauthorized(() => {
		return api.text.getSchoolTypes();
	});
}

function fetchAiFilterValues() {
	notifyBugsnagNetwork('text', 'fetchAiFilterValues');
	return handleUnauthorized(() => {
		return api.text.getAiFilterValues();
	});
}

function fetchWorkloads() {
	notifyBugsnagNetwork('text', 'fetchWorkloads');
	return handleUnauthorized(() => {
		return api.text.getWorkloads();
	});
}

function fetchTeachingFormats() {
	notifyBugsnagNetwork('text', 'fetchTeachingFormats');
	return handleUnauthorized(() => {
		return api.text.getTeachingFormats();
	});
}

function fetchTeacherRoles() {
	notifyBugsnagNetwork('text', 'fetchTeacherRoles');
	return handleUnauthorized(() => {
		return api.text.getTeacherRoles();
	});
}

function fetchFederalStates() {
	notifyBugsnagNetwork('text', 'fetchFederalStates');
	return handleUnauthorized(() => {
		return api.text.getFederalStates();
	});
}

function fetchSchools(payload: { textQuery: string }) {
	notifyBugsnagNetwork('text', 'fetchSchools', { ...payload });
	return handleUnauthorized(() => {
		return api.text.getSchools(payload);
	});
}

function fetchSchoolStages() {
	notifyBugsnagNetwork('text', 'fetchSchoolStages');
	return handleUnauthorized(() => {
		return api.text.getSchoolStages();
	});
}

export default service;
